import {React,  useRef} from "react";
//import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
//import Calendar from 'rc-year-calendar';
//import 'rc-year-calendar/locales/rc-year-calendar.it';
import RouterContext from "../../context/RouterContext";
import {updateSedute} from "./Utils";
import {properties} from "../../utils/properties";
import multiMonthPlugin from '@fullcalendar/multimonth'
import FullCalendar from '@fullcalendar/react'
import itLocale from '@fullcalendar/core/locales/it'
import interactionPlugin from "@fullcalendar/interaction" 

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@mui/material";


export default function CalendarView() {
  //const history = useHistory();
  var myRef= useRef()
  const navigate = useNavigate();
  const [meetingData, setMeetingData] = useState([]);
  const [bothRoles, setBothRoles] = useState(false);
  const [threeRoles, setThreeRoles] = useState(false);
  const [secondLevelButtons, setSecondLevelButtons]= useState(false);    
  const { pageRouter, setPageRouter } = useContext(RouterContext);
  const [startingYear, setStartingYear]= useState(0);
  var lastMeeting= useRef(null);

  const [notificationAvailable, setNotificationAvailable] = useState(null);
  const [dialog, setDialog] = useState(null);
  

  const handleNotificationAvailable = (dateString,textString, id) => {    
      //console.log("HNA",dateString, textString);
    return new Promise((resolve) => {

      const handleChoice = (choice, id) => {
        console.log("called", choice, id);
        var xhr = new XMLHttpRequest();                        
        xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix+'/core/rest/updateStatoFieldUser.php',true);
        xhr.withCredentials = true;
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

        xhr.onload = function (e) {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {                                                    
                      console.log("OK",xhr);                      
                      const response = JSON.parse(xhr.responseText);
                      setDialog(null);
                      resolve(choice);
                        
                }
              }        
        };

        xhr.onerror = function (e) {
            console.error("Error 27", xhr);
            //localStorage.clear();          
            setDialog(null);
            resolve(choice);  
            navigate("/login");
        };
       
      let urlEncodedData = "id=" + id+ "&value=" + choice;  
      xhr.send(urlEncodedData);
      };

    setDialog(      
      <Dialog open={true} 
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          handleChoice(0,id); 
        }        
      }}
      fullWidth maxWidth="sm">
              <DialogTitle sx={{ textAlign: "center" }}>
              {dateString}
              </DialogTitle>
              <DialogContent dividers>
                <Typography sx={{ textAlign: "justify", fontSize: 18 }}>
                  {textString}
                </Typography>
              </DialogContent>
              <DialogActions sx={{ flexDirection: "column", gap: 1, alignItems: "stretch", p: 2 }}>
                <Button sx={{ marginLeft: "10px", marginRight:"10px" }}  variant="contained" color="success"  onClick={() => handleChoice(1,id)}>✅ CONFERMO LA PARTECIPAZIONE IN PRESENZA</Button>
                <Button sx={{ marginLeft: "10px", marginRight:"10px" }} variant="contained" color="success"  onClick={() => handleChoice(2,id)}>💻 CONFERMO LA PARTECIPAZIONE DA REMOTO</Button>
                <Button sx={{ marginLeft: "10px", marginRight:"10px" }} variant="contained" color="inherit" onClick={() => handleChoice(4,id)}>⏳ NON SO ANCORA, RICORDAMELO PIU' TARDI</Button>
                <Button sx={{ marginLeft: "10px", marginRight:"10px" }} variant="contained" color="inherit"  onClick={() => handleChoice(3,id)}>❌ NON RIESCO A PARTECIPARE ALLA SEDUTA</Button>
              </DialogActions>
      </Dialog>
      );
    });

  }



useEffect(() => {
  
  if (localStorage.getItem("ruolo") !== "2" && localStorage.getItem("ruolo") !== "20" && localStorage.getItem("ruolo") !== "21") {  
      const scelta="nessunaNotifica";
      setNotificationAvailable(scelta);
  }
  else{  
      let mounted = true;
      const run = () => {
        const xhr = new XMLHttpRequest();
        const url = properties.productionUrl + properties.productionUrlSuffix + "/core/rest/checkNotifications.php";

        xhr.open("POST", url, true);
        xhr.withCredentials = true;
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

        xhr.onload = async function () {
          console.log("POST",xhr.readyState,xhr.status);
          if (xhr.readyState === 4 && xhr.status === 200) {
            try {
              const obj = JSON.parse(xhr.responseText);
              console.log("ID",obj.id)
              if (!mounted) return;
              
              const scelta = await handleNotificationAvailable(obj.date ?? "", obj.text ?? "", obj.id ?? "");
              console.log("Scelta utente:", scelta);

              if (!mounted) return;
              if (scelta != null) setNotificationAvailable(scelta);
            } catch (err) {
              console.error("JSON parsing error:", err);
            }
          }
          if (xhr.readyState === 4 && xhr.status === 404) {
            //NO NOTIFICHE
            const scelta="nessunaNotifica";
            setNotificationAvailable(scelta);
          }

        };

        xhr.onerror = function () {
          console.error("XHR network error");
        };

        xhr.send(null);
      };
      run();


  return () => {
    mounted = false;
  };
}
}, []);

  
  const updateUI = function(jsonData) {      
        console.log("UPDATEUI-CV");
        var entireMeeting = Object.entries(jsonData);                    
        var orderMeeting = [];
        var colore='#30720f';
        for (var i = entireMeeting.length - 1; i >= 0; i--) {          
            if(entireMeeting[i][1]["organo"]==="Consiglio")
                colore='#BF360C';
            else{
                if(entireMeeting[i][1]["organo"]==="Collegio")
                    colore='#666999';
                else
                    colore='#30720f';
            }
            var dateLabel=entireMeeting[i][0].substring(4, 8).concat("-").concat(entireMeeting[i][0].substring(2, 4)).concat("-").concat(entireMeeting[i][0].substring(0, 2));
            console.log(dateLabel);
            var eachMeeting = {
                //id: entireMeeting[i][0],
                name: 'Seduta del '.concat(entireMeeting[i][1]["dataSeduta"]),                              
                //location: entireMeeting[i][0],          
                //startDate: new Date(dateLabel),
                //endDate: new Date(dateLabel),
                //title: 'Seduta del '.concat(entireMeeting[i][1]["dataSeduta"]),              
                //date:new Date(dateLabel),
                //start:new Date(dateLabel),
                //end:new Date(dateLabel),
                //color: colore,  
                //backgroundColor: colore,
                //borderColor: colore,  
                //date: new Date(dateLabel),
                date:dateLabel,
                //date:"2024-02-27",
                //color: entireMeeting[i][1]["color"],
                //backgroundColor: entireMeeting[i][1]["color"],
                //borderColor: entireMeeting[i][1]["color"],    
                color: colore,
                //backgroundColor: colore,
                //borderColor: colore,   
            };            
            orderMeeting.push(eachMeeting);            
            if(lastMeeting.current===undefined) {
                            //console.log("1",lastMeeting, eachMeeting.startDate);
                lastMeeting.current=eachMeeting.startDate;
            }
            else{
                if (lastMeeting.current < eachMeeting.startDate){                
                    lastMeeting.current=eachMeeting.startDate;              
                }
            }
        }      
        //setStartingYear(lastMeeting.current.getFullYear());        
        /*var today={
            id: 0,
            name: 'Oggi',              
            location: '',          
            startDate: new Date(),
            endDate: new Date(),
            color: '#FF0000',                                          
        };
        orderMeeting.push(today);*/
        console.log("MEETING",orderMeeting);
        setMeetingData(orderMeeting);
  }
  
   const doPostSedute2 = function() {
        console.log("doing sedute post CV");
        var xhr2 = new XMLHttpRequest();                
        //xhr2.open('POST', properties.productionUrl+'/rest/checkSeduteJson',true);
        xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix+'/core/rest/checkSeduteJsonCollegio.php',true);         
        xhr2.withCredentials = true;
        xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
        xhr2.onload = function (e) {      
            if (xhr2.readyState === 4) {
                if (xhr2.status === 200) {                              
                    //console.log("OK92",xhr2);
                    var responseText = xhr2.responseText;                    
                    var obj=JSON.parse(responseText);
                    //console.log("OK93",obj, obj.status);          
                    if(obj.status==="204" ){                             
                        console.log("OK DOPOSTSEDUTE2 204",xhr2);                                                
                        const jsonListSedute = JSON.parse(localStorage.getItem("listSeduteCollegio"));
                        updateUI(jsonListSedute);
                        
                    }              
                    else{
                        //status 201
                        console.log("OK DOPOSTSEDUTE2 201",xhr2);  
                        
                        try{
                        localStorage.setItem("listSeduteCollegio", obj.content);
                        localStorage.setItem("listSeduteVersionCollegio", obj.date);                                 
                        }
                        catch(error) {
                            console.log("LOCALSTORAGE ISSUE", error);
                        }                          
                        const jsonListSedute = JSON.parse(obj.content);
                        updateUI(jsonListSedute);                        
                    }
                } 
                else {                    
                    console.log("Errore 3: Recuperando la lista sedute o non presenti sedute CdG per il ruolo dell'utente");                      
                }
            }
        };

        xhr2.onerror = function (e) {
            console.error("Error 22", xhr2.statusText);
        };
                
        let urlEncodedData = null; //"idf=" + meetingId;       

        if (localStorage.listSeduteCollegio!=='' &&localStorage.listSeduteCollegio!==undefined){            
        //console.log( "QUINDI00");
        const currentData=localStorage.getItem("listSeduteVersionCollegio");        
        urlEncodedData = "date=" + currentData;                    
    } 

    
        //console.log("CALVIEW",urlEncodedData);
        xhr2.send(urlEncodedData);
    }


 
    useEffect(() => {     
        if(notificationAvailable === null) return;
        console.log("USEEFFECT CV");    
        console.log("Arrivo qui", document.referrer);  
        if(localStorage.getItem("new_ui")=== undefined || localStorage.getItem("new_ui")=== null || localStorage.getItem("new_ui")=== "false"){                    
            navigate("/collegio",{ replace: true });  
        }              

        if (!window.cordova)
        {
          if(localStorage.getItem("ruolo")==="1"||localStorage.getItem("ruolo")==="2"){
              setBothRoles(true);
          }     
          if(localStorage.getItem("ruolo")==="12"||localStorage.getItem("ruolo")==="21"){
            setThreeRoles(true);
            }     
        }
        else {
          var onSuccess = function(response)
          {
            console.log("OK LOGIN 33");
            var obj=JSON.parse(response);
            var ruolo = obj.Ruolo;
        
            if(ruolo=="1"||ruolo=="2"){
                setBothRoles(true);
            }
            if(ruolo =="12" ||ruolo =="21" ){
                setThreeRoles(true);
            }
          }
        
          var onError = function() {}
        
          window.getInfo3(onSuccess, onError);
        }             

                           
        if(!window.cordova){        
        //CHECK AUTHENTICATION
            var xhr = new XMLHttpRequest();                
            //xhr.open('POST', properties.productionUrl+'/rest/ping',true);
            xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix+'/core/rest/ping.php',true);
            xhr.withCredentials = true;
            xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    
            xhr.onload = function (e) {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {                         
                    console.log("OK",xhr);                       
                    updateSedute("Collegio",doPostSedute2, updateUI);                          
                } else {
                    console.error("Error 1", xhr);   
                    localStorage.clear();                                     
                    navigate("/login");  
                }
            }
            };
    
            xhr.onerror = function (e) {
                console.error("Error 2", xhr);
                localStorage.clear();                
                navigate("/login");  
            };
             
            let urlEncodedData = null; 
            xhr.send(urlEncodedData);
        //CHECK AUTHENTICATION
        }
        
        if (window.cordova){           
            updateSedute("Collegio",doPostSedute2, updateUI);    
        }
       
    }, 
    //[]);
    [notificationAvailable]);


    const onFabClick= (e ) => {           
        //FAB aggiunta ambito
        console.log("OFC",e);                    
        navigate("/calendar");         
      };

      const onFabClick2= (e ) => {                   
        console.log("OFC-2",e);                        
        navigate("/calendarConsiglio");
      };

    function formatDate(dateString) {
        const [year, month, day] = dateString.split("-");
        return `${day}${month}${year}`;
}
   /*const topicList = (e) => {    
    console.log("called topic list CV",e);
    //const dateOk=formatDate(e.dateStr);    
    //navigate("/fascicoli/"+ dateOk+"/summary" );    
    //navigate("/collegio/"+dateOk);      
    const dateOk=formatDate(e.dateStr);
    const clickedCell = e.jsEvent.target;          
    const cellBackgroundColor = window.getComputedStyle(clickedCell).backgroundColor;
    if (cellBackgroundColor === "rgb(102, 105, 153)") { // Collegio Sindacale        
        console.log("Cliccato un giorno con eventi collegio.");
        navigate("/collegio/"+ dateOk );
    } else if (cellBackgroundColor === "rgb(191, 54, 12)") { // Consiglio Generale
          navigate("/consiglio/"+ dateOk );
        console.log("Cliccato un giorno con eventi consiglio generale");
    } else if (cellBackgroundColor === "rgb(48, 114, 15)") { // Comitato di Gestione
          console.log("Cliccato un giorno con eventi comitato di gestione");
          navigate("/fascicoli/"+ dateOk+"/summary" );
    }else {
          console.log("Nessuna logica specifica per questo colore.");
    }
    };
*/
function containsColor( val, rgbColor){
    const dataDateAttr = val.attributes['data-date'];
    if (dataDateAttr && dataDateAttr.ownerElement) {
      const ownerElement = dataDateAttr.ownerElement;      
      const allDescendants = ownerElement.querySelectorAll('*');      
      const hasTargetBackground = Array.from(allDescendants).some(el => {
        const style = window.getComputedStyle(el);
        return style.backgroundColor === rgbColor;
        });

      if (hasTargetBackground) {
        console.log('Trovato un elemento con background-color di interesse');
        return true;
        
      } else {
        console.log('Nessun elemento con background-color di interesse');
      }
    } else {
      console.log('Attributo data-date non trovato.');
    }
    return false;
  } 

const topicList = (e) => {    
    if( properties.verboseLog==1)
        console.log("called topic list CV",e);
            
    const dateOk=formatDate(e.dateStr);
    //const clickedCell = e.jsEvent.target;          

    //const cellBackgroundColor = window.getComputedStyle(clickedCell).backgroundColor;
    //if( properties.verboseLog==1)
    //    console.log("PDPM",e.dayEl, clickedCell, window.getComputedStyle(clickedCell),cellBackgroundColor,clickedCell);
   
    
    //if (cellBackgroundColor === "rgb(102, 105, 153)") { // Collegio Sindacale        
    if (containsColor(e.dayEl,"rgb(102, 105, 153)")) { // Collegio Sindacale        
        if( properties.verboseLog==1)
            console.log("Cliccato un giorno con eventi collegio.");
        navigate("/collegio/"+ dateOk );
    } 
    //else if (cellBackgroundColor === "rgb(191, 54, 12)") { // Consiglio Generale
    else if (containsColor(e.dayEl,"rgb(191, 54, 12)")) { // Consiglio Generale
          navigate("/consiglio/"+ dateOk );
          if( properties.verboseLog==1)
            console.log("Cliccato un giorno con eventi consiglio generale");
    }     
    //else if (cellBackgroundColor === "rgb(48, 114, 15)" || containsColor(e.dayEl,"rgb(48, 114, 15)")) { // Comitato di Gestione
    else if (containsColor(e.dayEl,"rgb(48, 114, 15)")) { // Comitato di Gestione
            if( properties.verboseLog==1)  
                console.log("Cliccato un giorno con eventi comitato di gestione");
            navigate("/fascicoli/"+ dateOk+"/summary" );
    }
    else {
          console.log("Nessuna logica specifica per questo colore.");
    }

    };

 
  return (
    <div style={{marginTop:"10px",paddingRight:"20px",paddingLeft:"20px"}}>
        {bothRoles ?(
         <Tooltip title="Comitato di Gestione" placement="left">
            <Fab aria-label="add"                 
                //variant="contained" 
                onClick={(event) => {onFabClick(event) }}                
                style={{
                    margin: 0,
                    //background: "#30720f",
                    background: "#30720f",
                    top: 'auto',
                    right: 10,
                    bottom: 25,
                    color: '0xFFFFFF',
                    left: 'auto',
                    position: 'fixed',}}>                    
                    <ArrowForwardIosIcon />                    
            </Fab>  
          </Tooltip>
       ):( <></>)}
           {threeRoles ?(
   <Tooltip title="Altri Organi" placement="left">
      <Fab aria-label="add"                 
          //variant="contained"           
          onClick={(event) => {setSecondLevelButtons(!secondLevelButtons) }}           
          style={{
              margin: 0,
              //background: "#30720f",
              background: "#CCCCCC",
              top: 'auto',
              //left: 10,
              right: 10,
              bottom: 25,
              color: '0xFFFFFF',
              left: 'auto',
              position: 'fixed',}}>                    
              <MoreHorizIcon />                  
      </Fab>  
    </Tooltip>
 ):( <></>)}
   {threeRoles && secondLevelButtons ? (
    <div> 
          <Tooltip title="Comitato di Gestione" placement="left">
            <Fab aria-label="add2"                 
                  //variant="contained" 
                  size='medium'
                  onClick={(event) => {onFabClick(event) }}
                  
                  style={{
                      margin: 0,
                      background: "#30720f",
                      top: 'auto',                     
                      right: 10,
                      bottom: 90,                      
                      left: 'auto',
                      position: 'fixed',}}>                    
                      <ArrowForwardIosIcon />                        
            </Fab>       
        </Tooltip>
        <Tooltip title="Consiglio Generale" placement="left">
            <Fab aria-label="add3"                                   
                  size='medium'
                  onClick={(event) => {onFabClick2(event) }}                  
                  style={{
                      margin: 0,
                      background: "#BF360C",
                      top: 'auto',                     
                      right: 10,
                      bottom: 145,
                      //color: '0xFF0000',
                      left: 'auto',
                      position: 'fixed',}}>                    
                      <ArrowForwardIosIcon />
            </Fab>
        </Tooltip>       
                  </div> 
            ): (<></>)}

{/**
      <Calendar                    
          year= {startingYear}          
          language="it"    
          minDate= {new Date("2016/01/01")}       
          maxDate= {new Date().setDate(new Date().getDate()+180)}
          style= "background"
          enableContextMenu={true}          
          dataSource={meetingData}          
          onDayClick={e => topicList(e)}
          />
*/}
    
    <FullCalendar      
            ref={myRef}
            plugins={[ multiMonthPlugin,interactionPlugin ]}
            initialView="multiMonthYear"
            locale={itLocale}
            //multiMonthMaxColumns= {4}
            //eventBackgroundColor={'red'}
            //eventBorderColor={'red'}
            //eventTextColor={'red'}
            //eventDisplay={'background'}
            //aspectRatio={1.7} 
            height="auto"            
            multiMonthMaxColumns= {4}            
            eventDisplay={'background'}
            contentHeight="auto"     
            aspectRatio={2.5} 
            
            eventDidMount={(info) => {              
                info.el.style.backgroundColor = info.event.extendedProps.color;
                info.el.style.borderColor = info.event.extendedProps.color;
                info.el.style.opacity = "0.8"; 
            }}

            eventColor="#30720E"
            headerToolbar={{
                //left: 'prev,next today',
                right: 'prev,next today',
                center: 'title',
                left: '',
            }}
            //eventColor={'red'}
            dateClick={e => topicList(e)}
            //dateClick={topicList}
            //events={events}    
            events={meetingData}    
            />
        {/*    <style>
                {`
                .fc-toolbar.fc-header-toolbar .fc-customLabel-button {
                    background: none;
                    border: none;
                    font-size: 1.5em;
                    color: green; 
                    cursor: default;
                    font-weight: bold;
                    padding: 0;
                    //pointer-events: none;
                }
                .fc-event,.fc-event-bg {
                    background-color: #30720E !important; 
                    opacity: 1 !important;  
                    border-color: #30720E !important;
                }
                `}
            </style>  */}
             <div>
            {dialog}        
        </div>   

      </div>
  );
  
  }  
